var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0159 11.9695L14.0258 11.974L14.0358 11.9782L17.4763 13.4527C17.4769 13.453 17.4775 13.4533 17.4782 13.4535C17.8521 13.6172 18.0357 14.0036 17.9316 14.3754L17.9253 14.3977L17.9201 14.4202L17.1819 17.6194L17.1749 17.6494L17.1699 17.6798C17.1194 17.9824 16.8509 18.2505 16.3984 18.2505C8.44291 18.2505 2 11.8076 2 3.85206C2 3.40912 2.26612 3.10976 2.6102 3.03807L2.62068 3.03589L2.63111 3.03348L5.83033 2.2952L5.83034 2.29524L5.83884 2.2932C6.23558 2.19798 6.63459 2.40085 6.79711 2.7727L8.30742 6.28504C8.30747 6.28516 8.30752 6.28528 8.30757 6.2854C8.43335 6.57938 8.3504 6.99931 8.05135 7.27345C7.02778 8.10751 6.64612 9.68976 7.59386 10.8659C8.1372 11.5401 8.75666 12.1535 9.44234 12.6929C10.6196 13.6188 12.1876 13.2373 13.0203 12.2241C13.2845 11.9092 13.6877 11.8203 14.0159 11.9695Z",
    stroke: "#E6EAEB",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.81609b785ff5ebf1785b81f3a6861cad.svg";
export { ForwardRef as ReactComponent };